import Grid from "@mui/material/Grid";
import { Box, Stack, Typography } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import {
  BasicPostApplied,
  BasicPostAppliedNoLabels,
  BasicPostAppliedSingleValue,
} from "./components/basic/BasicPostApplied";
import {
  BasicDetail,
  BasicDetailNoLabels,
} from "./components/basic/BasicDetail";
import {
  BasicLanguage,
  BasicLanguageDetail,
  BasicLanguageNoLabels,
} from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import {
  BasicSkillsNoLabels,
  BasicSkillsOneLineHorz,
  BasicSkillsSmallHorz,
  BasicSkillsTwoRows,
  BasicSkillsVer,
  BasicSkillsVerValue,
} from "./components/basic/BasicSkills";
import {
  BasicPassport,
  BasicPassportNoLabels,
} from "./components/basic/BasicPassport";
import { BasicFullName, BasicNameOnly } from "./components/basic/BasicFullName";
import { BasicFace, BasicFaceFixed } from "./components/basic/BasicFace";
import { BasicStand, BasicStandFixed } from "./components/basic/BasicStand";
import { BasicRemarksVer } from "./components/basic/BasicRemarks";
import { BasicReference } from "./components/basic/BasicReference";
import {
  BasicPassportScan,
  BasicPassportScanFixed,
} from "./components/basic/BasicPassportScan";
import { BasicHeader } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicTitleSingleLang } from "./components/basic/BasicTitle";
import { tt } from "../../../data/langUtility";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
  office: string;
}
function SanadTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
  office,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={0}
          sx={{
            p: 0,
            // backgroundColor: backgroundColor,
            background:
              office === "alamri"
                ? "url(/alamri_top.jpg)"
                : office === "waada"
                  ? "url(/waada_top.jpg)"
                  : "url(/almansa_top.jpeg)",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "1300px",
            alignItems: "flex-start",
            alignContent: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <Grid container item xs={12} sx={{ alignSelf: "flex-start" }}>
            {/* Short Photo */}

            <Grid
              container
              item
              xs={9}
              sx={{ mt: 17, pb: 0 }}
              spacing={0}
              alignItems="center"
            >
              {cvTemplate && currentEmployee && (
                <>
                  <Grid item xs={12}>
                    <BasicNameOnly
                      currentEmployee={currentEmployee}
                      template={{
                        ...cvTemplate,
                        transparentTableBackground: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <BasicPostAppliedNoLabels
                      currentEmployee={currentEmployee}
                      template={{
                        ...cvTemplate,
                        transparentTableBackground: true,
                      }}
                      showHeader={false}
                      showProfession={false}
                      showSalary={true}
                      showContractPeriod={false}
                      showEmployeeTelephone={true}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <BasicPassportNoLabels
                      currentEmployee={currentEmployee}
                      template={{
                        ...cvTemplate,
                        transparentTableBackground: true,
                      }}
                      showHeader={false}
                      showPassportNumber={true}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={false}
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={3} sx={{ pt: 11, pl: 4 }}>
              {cvTemplate && currentEmployee && (
                <BasicFaceFixed
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, transparentTableBackground: true }}
                />
              )}
            </Grid>
          </Grid>

          <Grid container item xs={12} sx={{ alignSelf: "flex-start" }}>
            <Grid item md={4} xs={12}>
              {cvTemplate && currentEmployee && (
                <Stack
                  spacing={cvTemplate.spacing}
                  sx={{
                    alignItems: "center",
                    mt: 18,
                    pl: 3,
                  }}
                >
                  <BasicStandFixed
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                      transparentTableBackground: true,
                    }}
                  />
                </Stack>
              )}
            </Grid>
            <Grid item md={8} xs={12} sx={{ pt: 15 }}>
              {cvTemplate && currentEmployee && (
                <>
                  <BasicDetailNoLabels
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                      transparentTableBackground: true,
                    }}
                    showHeader={false}
                    showReference={false}
                    showNationality={true}
                    showPassportNumber={false}
                    showReligion={true}
                    showDateOfBirth={true}
                    showAge={true}
                    showPlaceOfBirth={true}
                    showMaritalStatus={true}
                    showNumberOfChildren={true}
                    showWeightHeight={true}
                    showComplexion={false}
                    showEducation={true}
                    showLivingTown={false}
                    showEmployeeTelephone={true}
                    showContactName={false}
                    showContactTelephone={false}
                  />
                </>
              )}
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <Grid
              item
              md={6}
              xs={12}
              sx={{
                pt:
                  currentEmployee?.workExperience &&
                  currentEmployee?.workExperience?.length <= 1
                    ? 16
                    : 12,
              }}
            >
              <BasicLanguageNoLabels
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  transparentTableBackground: true,
                }}
                showEducation={false}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sx={{
                pt:
                  currentEmployee?.workExperience &&
                  currentEmployee?.workExperience?.length <= 1
                    ? 10
                    : 7,
              }}
            >
              <BasicSkillsNoLabels
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  transparentTableBackground: true,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          // backgroundColor: backgroundColor,
          background:
            office === "alamri"
              ? "url(/alamri_bottom.jpg)"
              : office === "waada"
                ? "url(/waada_bottom.jpg)"
                : "url(/almansa_bottom.jpeg)",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "1500px",
        }}
      >
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 52,
            }}
          >
            <BasicPassportScanFixed
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default SanadTemplate;
